import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import languages from "languages/languages";
import styles from "./Keyboard.module.css";
import searchSvg from "assets/images/search.svg";
import deleteSvg from "assets/images/delete.svg";
import playClickSpecial from "utils/playClickSpecial";

function Keyboard(props) {
  const langState = useSelector((state) => state.language.lang);
  const titleSearch = languages[langState]["Tìm Kiếm"];
  const titleSpace = languages[langState]["Dấu cách"];
  const titlePlaceholder =
    languages[langState]["Nhập tên gian hàng bạn muốn tìm kiếm ..."];
  const [valueOutput, setvalueOutput] = useState({
    value: props.oldVal || "",
  });

  const outputRef = useRef();
  const position = useRef(props.oldVal ? props.oldVal.length : 0);

  useEffect(() => {
    if (outputRef.current.createTextRange) {
      const range = outputRef.current.createTextRange();
      range.move("character", position.current);
      range.select();
    } else {
      if (outputRef.current.selectionStart) {
        outputRef.current.focus();
        outputRef.current.setSelectionRange(position.current, position.current);
      } else {
        outputRef.current.focus();
      }
    }
  }, [valueOutput]);

  function handleClick(e) {
    e.preventDefault();
    playClickSpecial();
    const keyVal = e.target.value;

    let startIndex = position.current;
    let endIndex = position.current;
    const selectionStart = outputRef.current.selectionStart;
    const selectionEnd = outputRef.current.selectionEnd;
    if (selectionEnd - selectionStart > 0) {
      startIndex = selectionStart;
      endIndex = selectionEnd;
    }

    const outputVal = outputRef.current.value;
    const outputValLth = outputVal.length;
    const newOutputVal =
      outputVal.substring(0, startIndex) +
      keyVal +
      outputVal.substring(endIndex, outputValLth);
    setvalueOutput({ value: newOutputVal });
    position.current++;
    //console.log(position.current);
  }

  function deleteKeyboard(e) {
    e.preventDefault();
    playClickSpecial();

    const outputVal = outputRef.current.value;
    const outputValLth = outputVal.length;
    if (!outputValLth) return;

    let startIndex = position.current - 1;
    let endIndex = position.current;
    const selectionStart = outputRef.current.selectionStart;
    const selectionEnd = outputRef.current.selectionEnd;
    if (selectionEnd - selectionStart > 0) {
      startIndex = selectionStart;
      endIndex = selectionEnd;
    }

    const newOutputVal =
      outputVal.substring(0, startIndex) +
      outputVal.substring(endIndex, outputValLth);
    setvalueOutput({ value: newOutputVal });
    if (position.current > 0 && selectionEnd - selectionStart <= 0)
      position.current--;
    //console.log(position.current)
  }

  function handleChange(e) {
    const outputVal = e.target.value;
    setvalueOutput({ value: outputVal });
  }

  function handleInputClick(e) {
    const selectionStart = outputRef.current.selectionStart;
    position.current = selectionStart;
    //console.log(selectionStart);
  }

  const firstRow = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  const firstRowInput = firstRow.map((val) => (
    <input type="button" key={val} value={val} onClick={handleClick} />
  ));

  const secondRow = [
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "-",
  ];
  const secondRowInput = secondRow.map((val) => (
    <input type="button" key={val} value={val} onClick={handleClick} />
  ));

  const thirdRow = [
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    ";",
    ",",
  ];
  const thirdRowInput = thirdRow.map((val) => (
    <input type="button" key={val} value={val} onClick={handleClick} />
  ));

  const fourRow = [
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
    ",",
    ".",
    "/",
    "@",
  ];
  const fourRowInput = fourRow.map((val) => (
    <input type="button" key={val} value={val} onClick={handleClick} />
  ));

  return (
    <div className={styles.wrapper_keyboard}>
      <div className={styles.output}>
        <form action="" method="get">
          <img className={styles.img_search} src={searchSvg} alt="search svg" />
          <input
            type="text"
            name="output"
            id="output"
            placeholder={titlePlaceholder}
            autoComplete="off"
            ref={outputRef}
            value={valueOutput.value}
            onChange={handleChange}
            onClick={handleInputClick}
          />
          <button onClick={(e) => props.submit(e, valueOutput.value)}>
            {titleSearch}
          </button>
        </form>
      </div>

      <div className={styles.virtual_keyboard}>
        <div className="row justify-content-center">
          {firstRowInput}
          <button
            id="delete"
            className={styles.button}
            onClick={deleteKeyboard}
          >
            <img src={deleteSvg} alt="delete svg" />
          </button>
        </div>

        <div className="row justify-content-center">{secondRowInput}</div>
        <div className="row justify-content-center">{thirdRowInput}</div>
        <div className="row justify-content-center">{fourRowInput}</div>
        <button
            id="spacebar"
            className={styles.button_space}
            value=" "
            onClick={handleClick}
          >
            {titleSpace}
          </button>
      </div>
    </div>
  );
}

export default Keyboard;
